import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import formatDate from 'src/app/helpers/format-date';
import getName from 'src/app/helpers/format-name';
import { formatGroundPositionName } from 'src/app/helpers/get-ground-positions';
import { PalletState } from '../inspection.component';
import { StockSortParams } from 'src/app/core/services/stock.service';
import { Inspection } from '../../../core/data-sources/v3/inspection/inspection.type';

@Component({
  selector: 'app-inspection-table',
  templateUrl: './inspection-table.component.html',
  styleUrls: ['./inspection-table.component.scss']
})
export class InspectionTableComponent implements OnInit {
  @Input() data: Inspection[] = [];
  @Output() clicked = new EventEmitter();
  @Output() onFilterChange = new EventEmitter();
  @Output() onTaskRequest = new EventEmitter();
  @Output() onSelect = new EventEmitter();
  PalletState = PalletState;
  selectedGoodsTagRfids = new Set();
  appliedFilters = {};
  sortParams: StockSortParams;

  constructor() { }

  ngOnInit(): void {
  }

  getGroundPositionAlias(item) {
    return formatGroundPositionName(item.groundPosition, 'alias');
  }

  getUserName(user) {
    return getName(user);
  }

  formatTimestamp(timestamp: number) {
    return formatDate(timestamp);
  }

  getButtonText(good) {
    let text = 'ENVIAR';
    switch (good.inspectionState) {
      case 'AWAITING_STORAGE':
        text = 'NA FILA';
        break;
      case 'IN_PROCESS':
        text = 'EXECUTANDO';
        break;
    }
    if (this.selectedGoodsTagRfids.has(good.tagRfid)) {
      text += ` (${this.selectedGoodsTagRfids.size})`;
    }
    return text;
  }


  emitClicked(good, page) {
    this.clicked.emit({ good, page });
  }

  onFiltersApply(params: { sortParams, filterParams }) {
    this.appliedFilters = params?.filterParams;
    this.sortParams = this.setSortParams(params?.sortParams);
    this.onFilterChange.emit(params);
  }

  setSortParams(sort) {
    if (!sort || !sort.sortBy) {
      return;
    }
    return sort;
  }

  allGoodsIsChecked() {
    const eligible = this.data?.filter(g => g.state === PalletState.RECEIVED);
    if (eligible && eligible.length !== 0) {
      return eligible.length === this.selectedGoodsTagRfids.size;
    }
    return false;
  }

  selectGood(good) {
    if (!this.selectedGoodsTagRfids.has(good.tagRfid)) {
      this.selectedGoodsTagRfids.add(good.tagRfid);
    } else {
      this.selectedGoodsTagRfids.delete(good.tagRfid);
    }
    this.onSelect.emit(this.selectedGoodsTagRfids);
  }

  selectAllGoods() {
    const eligible = this.data?.filter(g => g.state === PalletState.RECEIVED);

    if (eligible.length === this.selectedGoodsTagRfids.size) {
      this.selectedGoodsTagRfids.clear();
    } else {
      for (const e of eligible) {
        this.selectedGoodsTagRfids.add(e.tagRfid);
      }
    }
    this.onSelect.emit(this.selectedGoodsTagRfids);
  }

}
